export class TrimValueConverter {
	fromView(value: any) {
		return value ? value.trim() : '';
	}
	toView(value: any) {
		return value ? value.trim() : '';
	}
}